import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

const DEFAULT_TITLE = 'MunilyWebpageAI';
const DEFAULT_FAVICON = 'favicon.ico';

@Injectable({
  providedIn: 'root',
})
export class PageBrandingService {
  private readonly title = inject(Title);

  /** Aplica título y favicon personalizados desde la configuración de white label */
  applyBranding(pageTitle?: string, faviconUrl?: string): void {
    if (pageTitle) {
      this.title.setTitle(pageTitle);
    }
    if (faviconUrl) {
      this.setFavicon(faviconUrl);
    }
  }

  /** Restaura título y favicon por defecto. */
  resetToDefault(): void {
    this.title.setTitle(DEFAULT_TITLE);
    this.setFavicon(DEFAULT_FAVICON);
  }

  private setFavicon(url: string): void {
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'shortcut icon';
      document.head.appendChild(link);
    }
    link.type = 'image/x-icon';
    link.href = url;
  }
}
